
function checkScreenWidthFooter() {
  const element = document.querySelector('.ie-footer-accordion');
  
  if (window.innerWidth < 1024) {
    element.classList.add('accordion');
  } else {
    element.classList.remove('accordion');
  }
}

checkScreenWidthFooter();

window.addEventListener('resize', checkScreenWidthFooter);
 
function Popup () {
  const OPEN_CLASS = 'tw-hidden';

  const TRIGGER_CLASS = 'popup__trigger';
  const CLOSER_CLASS = 'popup__closer';
  const DATA_POPUP_SELECTOR = 'data-popup-selector';

  this.ini = function () {
      this.addListeners();
  }

  this.addListeners = function () {
      let handlers = document.querySelectorAll('.' + TRIGGER_CLASS);
      for (let i = 0; i < handlers.length; ++i) {
          let handler = handlers[i];
          let popupSelector = handler.getAttribute(DATA_POPUP_SELECTOR);
          this.addListenerToOpener(handler, popupSelector);
          this.addListenersToClosers(popupSelector);
      }
  }

  this.addListenerToOpener = function (handler, popupSelector) {
      let self = this;
      handler.addEventListener('click', function() {
          self.open(popupSelector);
      });
  }

  this.addListenersToClosers = function (popupSelector) {
      let self = this;
      let popup = document.querySelector(popupSelector);
      popup?.addEventListener('click', function (event) {
          if (event.target.matches(popupSelector)) {
              self.close(popupSelector);
          }
      });

      let closers = popup?.querySelectorAll('.' + CLOSER_CLASS);
      if (closers) {
        for (let i = 0; i < closers.length; ++i) {
          let closer = closers[i];
          closer.addEventListener('click', function () {
              self.close(popupSelector);
          });
        }
      }
  }

  this.open = function (popupSelector) {
      document.querySelector(popupSelector).classList.remove(OPEN_CLASS);
      document.body.style.overflow = "hidden";
        document.addEventListener('keydown', function(event) {
        const key = event.key; // const {key} = event; in ES6+
        if (key === "Escape") {
          document.querySelector(popupSelector).classList.add(OPEN_CLASS);
          document.body.style.overflow = "auto";
        }
        });
  }

  this.close = function (popupSelector) {
      document.querySelector(popupSelector).classList.add(OPEN_CLASS);
      document.body.style.overflow = "auto";
  }
}

function Accordion () {
  const ACCORDION_CONTAINER_CLASS = 'accordion';
  const ACCORDION_FOLD_CLASS = 'accordion__fold';
  const ACTIVE_FOLD_CLASS = 'active';

  this.ini = function () {
      let accordions = document.querySelectorAll('.' + ACCORDION_CONTAINER_CLASS);
      for (let i = 0; i < accordions.length; ++i) {
          let accordion = accordions[i];
          this.addListeners(accordion);
      }
  }

  this.addListeners = function (accordion) {
      let self = this;
      let folds = accordion.querySelectorAll('.' + ACCORDION_FOLD_CLASS);
      for (let i = 0; i < folds.length; ++i) {
          let fold = folds[i];

          fold.addEventListener('click', function () {
              self.toggleFold(accordion, fold);
          });
      }
  }

  this.toggleFold = function (accordion, fold) {
      let open = fold.classList.contains(ACTIVE_FOLD_CLASS);
      let folds = accordion.querySelectorAll('.' + ACCORDION_FOLD_CLASS);
      for (let i = 0; i < folds.length; ++i) {
          folds[i].classList.remove(ACTIVE_FOLD_CLASS);
      }
      if (!open) {
          fold.classList.add(ACTIVE_FOLD_CLASS);
      }
  }
}
let accordion = new Accordion();
accordion.ini();
window.addEventListener('resize', checkScreenWidthFooter);
let popup = new Popup();
popup.ini();



function updateCartCount() {
  // Get the value from #desktop-cart-count element
  const desktopCartCount = document.getElementById('desktop-cart-count');
  let count = '';
  if (desktopCartCount) {
    count = desktopCartCount.textContent;
  }
  // Update the value of .ie-cart-count element
  const cartCountCopys = document.querySelectorAll('.cart-count-bubble-copy');
  cartCountCopys.forEach((cartCountCopy) => {
  cartCountCopy.querySelector('.ie-cart-count').textContent = count;
  if (count < 1){
    cartCountCopy.classList.add('!tw-hidden');
  } else{
    cartCountCopy.classList.remove('!tw-hidden');
  }

});

}


// product cell swiper JS
function renderCellSwipers(root = document){
  const productCells = root.matches?.('.ie-product-cell')
    ? [root]
    : root.querySelectorAll('.ie-product-cell');

  productCells.forEach(product => {
    const swiperElement = product.querySelector('.swiper-product-cell');
    if (!swiperElement) return;

    const setSwiperMoving = (swiper, isMoving) => {
      swiper.el.classList.toggle('ie-swiper-is-moving', isMoving);
    };

    swiperElement.classList.remove('ie-swiper-is-moving');

    if (swiperElement.swiper) {
      swiperElement.swiper.destroy(true, true);
    }

    new Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      centerInsufficientSlides: true,
      roundLengths: true,
      maxBackfaceHiddenSlides: 0,
      navigation: {
        nextEl: product.querySelector('.swiper-button-next'),
        prevEl: product.querySelector('.swiper-button-prev'),
      },
      on: {
        sliderFirstMove(swiper) {
          setSwiperMoving(swiper, true);
        },
        touchEnd(swiper) {
          requestAnimationFrame(() => {
            if (!swiper.destroyed && !swiper.animating) {
              setSwiperMoving(swiper, false);
            }
          });
        },
        transitionStart(swiper) {
          setSwiperMoving(swiper, true);
        },
        transitionEnd(swiper) {
          setSwiperMoving(swiper, false);
        },
      }
    })
  });
}

document.addEventListener("drawer-refreshed", e => {
  renderCellSwipers()
})
renderCellSwipers()



function triggerShippingText(disable){
  const els = document.querySelectorAll(".cart-price--logistics");
  els.forEach(el => {
    if(disable) el.classList.add("tw-hidden");
    if(!disable) el.classList.remove("tw-hidden");
  })
}

function filterProductsByCollection() {
  const collectionParam = new URLSearchParams(location.search).get('collection');
  if (collectionParam) {
    const products = document.querySelectorAll('.ie-product-cell');
    const allBanners = document.querySelectorAll('.ie-grid-banner');

    products.forEach((product) => {
      const tags = product.dataset.tags;

      const isInCollection = tags && tags.includes(`collection:${collectionParam}`);
      if (!isInCollection) {
        product.remove();
      }
    });

    allBanners.forEach((banner) => {
      banner.remove();
    });
  }
}

filterProductsByCollection();

